import React from "react";
import Config from "@skin_config";

export const counterOfferRounding = num => {
    let regEx = new RegExp('^-?\\d+(?:\.\\d{0,' + (Config.odd.roundDecimalCoefficients || -1) + '})?'),
        price = num.toString().match(regEx)[0],
        lastElem = price.length - 1;

    if (price.charAt(lastElem) == 0) {
        return price.substring(0, lastElem);
    }
    return price;
};